import {makeAutoObservable} from "mobx";
import {IGroupRule} from "../../../api/ProductRulesApi";
import Rule from "./Rule";
import NameTemplateRule from "./NameTemplateRule";
import ImageSettingsRules from "./ImageSettingsRules";


export default class RuleGroup {
    constructor(group: IGroupRule) {
        this._group_name = group.name
        const rules = [];
        for (const rule of group.rules) {
            if(rule.type === NameTemplateRule.output_type) {
                rules.push(new NameTemplateRule(rule))
            } else if (rule.type === ImageSettingsRules.output_type) {
                rules.push(new ImageSettingsRules(rule))
            } else {
                rules.push(new Rule(rule))
            }
        }
        this._rules = rules;
        makeAutoObservable(this)
    }

    private _group_name: string;

    get group_name(): string {
        return this._group_name;
    }

    private _rules: Rule[];

    get rules(): Rule[] {
        return this._rules;
    }
}